// extracted by mini-css-extract-plugin
export var center = "RichTextImage-module--center--64fbf";
export var innerContainer = "RichTextImage-module--innerContainer--4373f";
export var left = "RichTextImage-module--left--f3ee7";
export var outerContainer = "RichTextImage-module--outerContainer--3c3e4";
export var right = "RichTextImage-module--right--10ed3";